import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { panFormToCertificate } from "src/pages/pan/view/Dialog/PanFormDialogBox/panFormToCertificate";
import EmployerCertificateTemplate from "./EmployerCertificateTemplate";
import { PcoFirm } from "./pcoFirms";
import { certificateIssuerFor } from "./certificateIssuer";
import {
  employerCertificateApplicant,
  employerCertificateDate,
} from "./employerCertificateApplicant";

/**
 * The Employer Certificate HTML for POST /employer-certificate/add, built
 * without opening the Download dialog — used by the PAN form to generate the
 * certificate on its own right after the PAN form is generated.
 *
 * Same template and same applicant values as the dialog; the only difference
 * is that nothing is mounted: the markup is rendered straight to a string.
 *
 * `data` is the application from GET /employer-certificate/get-application-by-id.
 * That endpoint carries no `randomNumber` ("employed with us since N years"),
 * so one is drawn here the way the employer listing draws it (1-5).
 */
export const employerCertificateHtml = (
  data: any,
  formData: any,
  applicationType?: string,
  /** The photo the PAN form just printed (cropped), over the stored copy. */
  photoUrl?: string,
  /** GET /pco-firm/get-all — a PCO certificate prints its firm's issuer + seal. */
  pcoFirms?: PcoFirm[],
  /** DSA: the agent's signature (resolveDsaSignature), over the stored one. */
  dsaSignatureImage?: string,
  /** DSA: the agent's seal with its paper removed (cleanDsaStamp). */
  dsaSealImage?: string
) => {
  const applicant = employerCertificateApplicant(
    data,
    panFormToCertificate(formData, applicationType)
  );
  const withYears = {
    ...data,
    randomNumber: data?.randomNumber || Math.floor(Math.random() * 5) + 1,
  };
  return renderToStaticMarkup(
    <EmployerCertificateTemplate
      data={withYears}
      {...applicant}
      photoUrl={photoUrl || applicant.photoUrl}
      todayDate={employerCertificateDate()}
      issuer={certificateIssuerFor(
        data,
        pcoFirms,
        applicant.officeAddress,
        dsaSignatureImage,
        dsaSealImage
      )}
    />
  );
};

export default employerCertificateHtml;
